<template>
<div>
    <!-- Modal for Lssa details -->
    <LssaDetails
        v-model="modalLssaDetailShow"
        :currentLssa="this.currentLssa"
        :editingLssa="this.editingLssa"
        :updateFinito="!updatingName"
        @updating-lssa="forwardingUpdating"
        @editing-lssa="forwardEditing" />

    <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
        <table :theme="theme" id="dataTableLssa" ref="tableLssa" class="table table-child">
            <tbody>
                <tr v-for="(lssa, arrayIndex) in lssa_array" :key="lssa.index + '-' + arrayIndex" class="tr_child" :style="{ 'display': (lssa.visible == false) ? 'none' : 'table-row'}">
                    <td style="background-color: white;">
                        <div v-if="lssa.product_image">
                            <img :src="pathDeviceImages + lssa.product_image" style="width:30px; margin-left:15px;" alt="icona lssa"/>
                        </div>
                        <div v-else>
                            <img :src="pathDeviceImages + '17230.jpg'" style="width:30px; margin-left:15px;" alt="icona lssa"/>
                        </div>
                        <div v-if="editingDesc && (editingDescIndex === lssa.index)">
                            <b-form-group 
                                label-for="lssaDesc" 
                                :description="lssaDescInfo"
                                class="pl-1">
                                <b-form-input
                                    id="lssaDesc"
                                    type="text"
                                    v-model="descLssa"
                                    :placeholder="$t('lssa.insert_desc')"
                                    size="sm"
                                    style="font-weight: bold;"
                                    :maxlength = "maxlengthDesc"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <div v-else>
                            <span style="font-size:smaller;" class="font-weight-bold pl-1">{{  lssa.module_description }}</span>
                        </div>
                        <div v-if="lssa.index != '97'">
                            <span style="font-size:smaller;" class="pr-1">{{ lssa.product_desc != '' ? lssa.product_desc:lssa.module_description }} : </span>
                            <span><strong>{{ lssa.index}}</strong></span>
                        </div>
                        <div v-else>
                            <span style="font-size:smaller;" class="pr-1">{{ lssa.product_desc!=''?lssa.product_desc:"LSSA IO" }} </span>
                        </div>
                    </td>
                    <!-- BUTTON ELLIPSIS -->
                    <td>
                        <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none col-2" no-caret right
                            id="dropdown-central" boundary="viewport" :aria-label="$t('lssa.option_lssa')">
                        <template v-slot:button-content>
                            <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                        </template>
                            <b-dropdown-item @click="showLssaDetails(lssa)">
                                {{ $t("cu_table_row.dropdown_dettaglio") }}
                            </b-dropdown-item>
                            <b-dropdown-item @click="initConfig(lssa)">
                                {{ $t("lssa.configura") }}
                            </b-dropdown-item>
                            <b-dropdown-item @click="rinominaLssa(lssa)">
                                {{ $t("lssa.rename") }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </td>
                    <td v-for="(ingresso, inputIndex) in lssa.inputs" :key="ingresso.input_number + '-' + inputIndex">
                        <div class="container">
                            <div class="row">
                                <div class="text-left"><strong>{{ ingresso.input_number }}</strong></div>
                            </div>
                            <div v-if="editingDesc && (editingDescIndex === lssa.index)" class="row">
                                <!-- :description="inputNameInfo(descInput[ingresso.input_number - 1])" -->
                                <b-form-group 
                                    :label-for="'lssaInput' + ingresso.input_number"                                    
                                    class="pr-1">
                                    <b-form-input
                                        :id="'lssaInput' + ingresso.input_number" 
                                        type="text"
                                        v-model="descInput[ingresso.input_number - 1]"
                                        :placeholder="$t('lssa.insert_desc')"
                                        size="sm"
                                        style="font-weight: bold;"
                                        class="placeholder-weight"
                                        :maxlength = "maxlengthDesc"
                                        :state="inputState(ingresso.input_number - 1)"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="inputNameInfo(ingresso.input_number - 1).error">
                                    {{ inputNameInfo(ingresso.input_number - 1).text }}
                                    </b-form-invalid-feedback>

                                    <b-form-text v-else>
                                    {{ inputNameInfo(ingresso.input_number - 1).text }}
                                    </b-form-text>
                                </b-form-group>
                            </div>
                            <div v-else class="row">
                                <div class="col-xl-12 p-0 text-left" style="font-size:x-small">
                                    <strong v-if="ingresso.desc != ''">{{ ingresso.desc }}</strong>
                                    <strong v-else>--</strong>
                                </div>
                            </div>
                            <div v-if="configLssa && (editingIndex === lssa.index)" class="row">
                                <div class="col-xl-12 p-0 text-left" style="font-size:x-small">
                                    <b-form-select
                                        v-model="selectedProgram[ingresso.input_number - 1]"
                                        :options="programOptions"
                                        size="sm"
                                        class="w-100"
                                    ></b-form-select>
                                </div>
                            </div>
                            <div v-else class="row">
                                <div class="col-xl-12 p-0 text-left" style="font-size:x-small; color: #04709C;">
                                    <strong>{{ ingresso.program }}</strong>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-5 p-0 text-left" style="font-size:x-small">{{ $t("lssa.address") }}:</div>
                                <div v-if="configLssa && (editingIndex === lssa.index)" class="col-xl-7 p-0 text-left" style="font-size:x-small">
                                    <b-form-select
                                        v-model="selectedIngresso[ingresso.input_number - 1]"
                                        :options="addressOptions"
                                        size="sm"
                                        class="w-100"
                                    ></b-form-select>
                                </div>
                                <div v-else class="col-xl-7 p-0 text-left" style="font-size:x-small">
                                    <strong>{{ ingresso.address != 0 ? ingresso.address : '' }}</strong>
                                </div>
                            </div>

                            <div v-if="configLssa && (editingIndex === lssa.index)" class="row">
                                <div class="p-0 text-left" style="font-size:x-small">{{ $t("lssa.negato") }}:</div>
                                <div class="p-0 text-left" style="font-size:x-small">
                                    <b-form-select
                                        v-model="selectedNegated[ingresso.input_number - 1]"
                                        :options="[{ text: $t('on'), value: 'ON' }, { text: $t('off'), value: 'OFF' }]"
                                        size="sm"
                                        class="w-100"
                                    ></b-form-select>
                                </div>
                            </div>
                            <div v-else class="row">
                                <div class="col-xl-8 p-0 text-left" style="font-size:x-small">{{ $t("lssa.negato") }}:</div>
                                <div class="col-xl-4 p-0 text-left" style="font-size:x-small">
                                    <strong>{{ ingresso.negated }}</strong>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl p-0 text-left" style="font-size:smaller">
                                    <i class="fa fa-circle"
                                        :class="[((ingresso.state == 0) || (ingresso.state == null)) ? 'dot-disconnected' : 'dot-connected', 'pr-1']"></i>
                                    <strong>{{ $t(decodificaLSSA(ingresso,lssa)) }}</strong>
                                </div>
                            </div>
                        </div>
                    </td>
                    <!-- PULSANTI DI CONFERMA -->
                    <td>
                        <div v-if="configLssa && (editingIndex === lssa.index)">
                            <b-button-group 
                                class="d-flex flex-column flex-xxl-row"
                                style="gap: 0.5rem;"
                            >
                                <b-button @click="saveConfigLssa(lssa)" class="mr-1" style="color: green" :aria-label="$t('save')" :content="$t('save')" v-tippy="{ placement : 'top',  arrow: true}">
                                    <i class="fa fa-2x fa-check" aria-hidden="true"></i>
                                </b-button>
                                <b-button @click="configLssa = false" style="color: red" :aria-label="$t('cancel')" :content="$t('cancel')" v-tippy="{ placement : 'top',  arrow: true}">
                                    <i class="fa fa-2x fa-close" aria-hidden="true"></i>
                                </b-button>
                            </b-button-group>
                        </div>
                        <div v-else-if="editingDesc && (editingDescIndex === lssa.index)">
                            <b-button-group                           
                                class="d-flex flex-column flex-xxl-row"
                                style="gap: 0.5rem;"
                            >
                                <b-button @click="saveDescLssa(lssa)" class="mr-1" style="color: green" :aria-label="$t('save')" :content="$t('save')" v-tippy="{ placement : 'top',  arrow: true}">
                                    <i class="fa fa-2x fa-check" aria-hidden="true"></i>
                                </b-button>
                                <b-button @click="editingDesc = false" style="color: red" :aria-label="$t('cancel')" :content="$t('cancel')" v-tippy="{ placement : 'top',  arrow: true}">
                                    <i class="fa fa-2x fa-close" aria-hidden="true"></i>
                                </b-button>
                            </b-button-group>                            
                        </div>
                        <div v-else>
                            <div v-if="lssa.error_com_cpu_lssa === 'ON'" :content="$t('details_cu_modal.cu_error_com_lssa')" v-tippy="{ placement : 'top',  arrow: true}">
                                <b-iconstack font-scale="2.2">
                                    <b-icon stacked icon="slash" style="color: red; "></b-icon>
                                    <b-icon stacked icon="arrow-left-right" style="color: red; "></b-icon>
                                </b-iconstack>
                            </div>
                            <div v-else :content="$t('details_lamp.lamp_no_error')" v-tippy="{ placement : 'top',  arrow: true}">
                                <i class="fa fa-2x fa-check check-ok" />
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </show-at>
    <!-- VERSIONE MOBILE -->
    <hide-at breakpoint="mediumAndAbove">
        <div>
            <b-card 
                v-for="(lssa, arrayIndex) in lssa_array" 
                :key="lssa.index + '-' + arrayIndex"
                :style="{ 'display': (lssa.visible == false) ? 'none' : 'block' }"
                class="lssaCard" no-body>
                <b-row>
                    <!-- checkbox > NO -->
                    <b-col cols="1" class="nopadding d-flex align-items-center">
                    </b-col>
                    <!-- image -->
                    <b-col cols="3" class="nopadding d-flex align-items-center">
                        <img v-if="lssa.product_image != null && lssa.product_image != ''"
                            :src="lssa.product_image.includes('|') ? pathDeviceImages + lssa.product_image.split('|')[0] : pathDeviceImages + lssa.product_image"
                            style="height:60px; width:auto;" alt="icona lssa"/>
                        <div v-else >
                            <img :src="pathDeviceImages + '17230.jpg'"
                                style="height:60px; width:auto;" alt="icona lssa"/>
                        </div>
                    </b-col>
                    <!-- desc, index-->
                    <b-col cols="7">
                        <!-- desc -->
                        <b-row>
                            <b-col cols="12">
                                <div v-if="editingDesc && (editingDescIndex === lssa.index)">
                                    <b-form-group 
                                        label-for="lssaDesc" 
                                        :description="lssaDescInfo">
                                        <b-form-input
                                            id="lssaDesc"
                                            type="text"
                                            v-model="descLssa"
                                            :placeholder="$t('lssa.insert_desc')"
                                            size="sm"
                                            style="font-weight: bold;"
                                            :maxlength = "maxlengthDesc"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                                <div v-else-if="lssa.module_description != null && lssa.module_description != ''">
                                    <span class="font-weight-bold">{{  lssa.module_description }}</span>
                                </div>
                                <div v-else>
                                    <span class="font-weight-bold">--</span>
                                </div>
                            </b-col>
                            <b-col cols="12">
                                <div v-if="lssa.index != '97'">
                                    <span style="font-size:smaller;">{{ lssa.product_desc != '' ? lssa.product_desc : '--' }}</span>
                                </div>
                                <div v-else>
                                    <span style="font-size:smaller;">{{ lssa.product_desc!='' ? lssa.product_desc : "LSSA IO" }}</span>
                                </div>
                            </b-col>
                        </b-row>
                        <!-- index -->
                        <b-row v-if="lssa.index != '97'">
                            <b-col cols="5" class="dataLabels">
                                {{$t("sicuro_mobile.index")}}
                            </b-col>
                            <b-col cols="7">                                                                        
                                <h4>{{ lssa.index }}</h4>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="5" class="dataLabels">
                                {{ $t("sicuro_mobile.num_input") }}
                            </b-col>
                            <b-col cols="7">
                                <h4>{{ lssa.inputs.length }}</h4>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="5" class="dataLabels">
                                {{ $t("sicuro_mobile.status") }}
                            </b-col>
                            <b-col v-if="lssa.error_com_cpu_lssa == 'ON'" cols="7">
                                <b-iconstack font-scale="1.5" >
                                    <b-icon stacked icon="slash" style="color:red"></b-icon>
                                    <b-icon stacked icon="arrow-left-right" style="color:red"></b-icon>
                                </b-iconstack>
                            </b-col>
                            <b-col v-else cols="7">
                                <i class="fa fa-check check-ok" />
                            </b-col>
                        </b-row>
                    </b-col>
                    <!-- modal detail, pulsante attivazione collapse INPUT -->
                    <b-col cols="1">
                        <b-row>
                            <b-col class="nopadding d-flex align-items-start">
                                <b-dropdown variant="link" size="lg"
                                    toggle-class="text-decoration-none" no-caret right>
                                    <template slot="button-content">
                                        <b><i class="fa fa-1x fa-ellipsis-v"
                                                style="color:black"></i></b>
                                    </template>
                                    <b-dropdown-item @click="showLssaDetails(lssa)">
                                        {{$t("cu_table_row.dropdown_dettaglio")}}
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="initConfig(lssa)">
                                        {{ $t("lssa.configura") }}
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="rinominaLssa(lssa)">
                                        {{ $t("lssa.rename") }}
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="nopadding d-flex align-items-start" >
                                <b-button p="2" style="background-color:#f4f4f4" size="sm" :disabled="(lssa.inputs.length === 0)"> 
                                    <i :class="isOpen['lssa' + lssa.index] ? 'fas fa-angle-down':'fas fa-angle-right'" @click="toggleInputs('lssa' + lssa.index)" /> 
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <!-------------------------------------------------->
                <!-------------------- Inputs ---------------------->
                <!-------------------------------------------------->
                <!-- @show="isOpen[lssa.index] = true"
                     @hide="isOpen[lssa.index] = false" -->
                <!-- class="text-left"  -->
                <b-collapse
                    :id="'collapse-lssa' + lssa.index" 
                    class="mt-2"
                >
                    <b-card
                        v-for="(ingresso, inputIndex) in lssa.inputs" :key="ingresso.input_number + '-' + inputIndex" 
                        class="inputCard" no-body>
                        <b-row>
                            <b-col cols="1" class="d-flex align-items-center">
                                <strong>{{ ingresso.input_number }}</strong>
                            </b-col>
                            <b-col cols="8">
                                <b-row>
                                    <b-col cols="12" v-if="editingDesc && (editingDescIndex === lssa.index)">
                                        <!-- :description="inputNameInfo(descInput[ingresso.input_number - 1])" -->
                                        <b-form-group 
                                            :label-for="'lssaInput' + ingresso.input_number"                                             
                                        >
                                            <b-form-input
                                                :id="'lssaInput' + ingresso.input_number" 
                                                type="text"
                                                v-model="descInput[ingresso.input_number - 1]"
                                                :placeholder="$t('lssa.insert_desc')"
                                                size="sm"
                                                style="font-weight: bold;"
                                                class="placeholder-weight"
                                                :maxlength = "maxlengthDesc"
                                                :state="inputState(ingresso.input_number - 1)"
                                            ></b-form-input>
                                            <b-form-invalid-feedback v-if="inputNameInfo(ingresso.input_number - 1).error">
                                            {{ inputNameInfo(ingresso.input_number - 1).text }}
                                            </b-form-invalid-feedback>

                                            <b-form-text v-else>
                                            {{ inputNameInfo(ingresso.input_number - 1).text }}
                                            </b-form-text>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" v-else>
                                        <div class="col-xl-12 p-0 text-left" style="font-size:smaller;">
                                            <strong v-if="ingresso.desc != ''">{{ ingresso.desc }}</strong>
                                            <strong v-else>--</strong>
                                        </div>
                                    </b-col>
                                    <b-col cols="5" class="dataLabels">
                                        {{ $t("lssa.function") }}
                                    </b-col>
                                    <b-col v-if="configLssa && (editingIndex === lssa.index)" cols="7">
                                        <b-form-select
                                            v-model="selectedProgram[ingresso.input_number - 1]"
                                            :options="programOptions"
                                            size="sm"
                                            class="w-100"
                                        ></b-form-select>
                                    </b-col>
                                    <b-col v-else cols="7">
                                        <h6>{{ ingresso.program }}</h6>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="5" class="dataLabels">
                                        {{ $t("lssa.address") }}
                                    </b-col>
                                    <b-col v-if="configLssa && (editingIndex === lssa.index)" cols="7">
                                        <b-form-select
                                            v-model="selectedIngresso[ingresso.input_number - 1]"
                                            :options="addressOptions"
                                            size="sm"
                                            class="w-100"
                                        ></b-form-select>
                                    </b-col>    
                                    <b-col v-else cols="7">
                                        <h6>{{ ingresso.address }}</h6>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="5" class="dataLabels">
                                        {{ $t("lssa.negato_short") }}
                                    </b-col>
                                    <b-col v-if="configLssa && (editingIndex === lssa.index)" cols="7">
                                        <b-form-select
                                            v-model="selectedNegated[ingresso.input_number - 1]"
                                            :options="[{ text: $t('on'), value: 'ON' }, { text: $t('off'), value: 'OFF' }]"
                                            size="sm"
                                            class="w-100"
                                        ></b-form-select>
                                    </b-col>
                                    <b-col v-else cols="7">
                                        <h6>{{ ingresso.negated }}</h6>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="2" class="d-flex align-items-center">
                                <i class="fa fa-circle"
                                        :class="[((ingresso.state == 0) || (ingresso.state == null)) ? 'dot-disconnected' : 'dot-connected', 'pr-1']">
                                </i>
                                <strong>{{ $t(decodificaLSSA(ingresso,lssa)) }}</strong>
                            </b-col>
                        </b-row>
                    </b-card>
                    <!-- PULSANTI DI CONFERMA MOBILE class="inputCard" -->
                    <b-card v-if="configLssa && (editingIndex === lssa.index)" no-body class="fixed-card">
                        <div class="d-flex justify-content-center">
                            <b-button-group>
                                <b-button @click="saveConfigLssa(lssa)" class="mr-4" style="color: green" :aria-label="$t('save')" :content="$t('save')" v-tippy="{ placement : 'top',  arrow: true}">
                                    <i class="fa fa-2x fa-check" aria-hidden="true"></i>
                                </b-button>
                                <b-button @click="configLssa = false" style="color: red" :aria-label="$t('cancel')" :content="$t('cancel')" v-tippy="{ placement : 'top',  arrow: true}">
                                    <i class="fa fa-2x fa-close" aria-hidden="true"></i>
                                </b-button>
                            </b-button-group>
                        </div>
                    </b-card>
                    <b-card v-else-if="editingDesc && (editingDescIndex === lssa.index)" no-body class="fixed-card">
                        <div class="d-flex justify-content-center py-1">
                            <b-button-group>
                                <b-button @click="saveDescLssa(lssa)" class="mr-4" style="color: green" :aria-label="$t('save')" :content="$t('save')" v-tippy="{ placement : 'top',  arrow: true}">
                                    <i class="fa fa-2x fa-check" aria-hidden="true"></i>
                                </b-button>
                                <b-button @click="editingDesc = false" style="color: red" :aria-label="$t('cancel')" :content="$t('cancel')" v-tippy="{ placement : 'top',  arrow: true}">
                                    <i class="fa fa-2x fa-close" aria-hidden="true"></i>
                                </b-button>
                            </b-button-group>     
                        </div>                       
                    </b-card>
                </b-collapse>
            </b-card>
        </div>
    </hide-at>
</div>
</template>

<script>
import {showAt, hideAt} from 'vue-breakpoints'
import LssaDetails from '@/components/LssaDetails.vue'

export default {
    name: 'LssaDisplay',
    components: { LssaDetails, showAt, hideAt},

    data()
    {
        return {
            currentLssa:null,
            updatingProduct:null,
            modalLssaDetailShow: false,
            theme: 'bootstrap4',
            pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,                 //pathDeviceImages for DEV : "https://d7e8bp38d6h8e.cloudfront.net/",
            programOptions: [
                { text: this.$t('lssa.no_function'), value: 'No function' },
                { text: this.$t('lssa.light_switch'), value: 'Light switch' },
                { text: this.$t('lssa.sub_distribution'), value: 'Sub distribution' },
                { text: this.$t('lssa.dynamic_light'), value: 'Dynamic light' },
                { text: this.$t('lssa.stairway_pushbutton'), value: 'Stairway pushbutton' },
                { text: this.$t('lssa.manual_reset'), value: 'Manual reset' },
                { text: this.$t('lssa.dynamic_scene'), value: 'Dynamic scene' }
            ],
            configLssa: false,   //se true mostra select per cambiare funzione ingressi LSSA
            editingIndex: null,
            addressOptions:  Array.from({ length: 768 }, (_, i) => ({
                text: `${i + 1}`,
                value: (i + 1)
            })),
            selectedProgram: [],
            selectedIngresso: [],
            selectedNegated: [],
            isOpen: {}, //così fatto: {'lssa02': true, 'lssa01': false, ecc}
            editingDesc: false,
            editingDescIndex: null,
            descLssa: '',
            descInput: [],
            maxlengthDesc: 30
        }
    },

    props: {
        lssa_array: null,
        editingLssa: Boolean,
        updatingName: Boolean,
        sendConfig: null,
        sendDesc: null
    },

    created() {
        if (Array.isArray(this.lssa_array)) {
            this.lssa_array.forEach(lssa => {
                // this.isOpen[lssa.index] = false;
                this.$set(this.isOpen, 'lssa' + lssa.index, false);
            });
            console.log("LssaDisplay created", this.lssa_array, this.isOpen);
        } else {
            console.warn('lssa_array is not ready yet');
        }
    },

    computed: {
        //prop che restituisce una stringa con i dati della stringa inserita, #caratteri od eventuali errori
        lssaDescInfo() {
            const nc = this.descLssa ? this.descLssa.length : 0;
            const validChars = /^[\p{L}\p{N}\s]*$/u.test(this.nomeCent);
            if (!validChars) return "<b style=\"color:red\">Sono presenti caratteri non ammessi</b>";
            if (nc > 30 || !validChars) {
                return "<b style=\"color:red\">" + nc + "/30 Caratteri</b>";
            }
            return "" + nc +"/30 Caratteri";
        },
    },
    methods: {
        inputNameInfo(id) {
            const name = this.descInput[id] || '';
            const nc = name.length;
            const validChars = /^[\p{L}\p{N}\s']*$/u.test(name);

            if (!validChars) {
                return { text: 'Sono presenti caratteri non ammessi', error: true };
            }
            if (nc == 0) {
                return { text: `${nc}/${this.maxlengthDesc} Caratteri`, error: null };
            }
            if (nc > this.maxlengthDesc) {
                return { text: `${nc}/${this.maxlengthDesc} Caratteri`, error: true };
            }

            return { text: `${nc}/${this.maxlengthDesc} Caratteri`, error: false };
        },
        inputState(id) {
            const info = this.inputNameInfo(id);
            return info.error === false ? true : (info.error === true ? false : null);
        },
        // //funzione che restituisce una stringa con i dati della stringa inserita, #caratteri od eventuali caratteri non ammessi
        // inputNameInfo(name) {
        //     console.log("inputNameInfo", name);
        //     const nc = (name && name.length) ? name.length : 0;
        //     const validChars = /^[\p{L}\p{N}\s]*$/u.test(name);
        //     if (!validChars) return "<b style=\"color:red\">Sono presenti caratteri non ammessi</b>";
        //     if (nc > 30 || !validChars) {
        //         return "<b style=\"color:red\">" + nc + "/30 Caratteri</b>";
        //     }
        //     return "" + nc +"/30 Caratteri";
        // },
        rinominaLssa(lssa) {
            this.descLssa = lssa.module_description;
            this.descInput = lssa.inputs.map(input => input.desc);
            this.editingDesc = true;
            this.editingDescIndex = lssa.index;
            //nel caso di visualizzazione a card, apro il collapse degli ingressi
            if (this.isOpen['lssa' + lssa.index] === false) {
                this.toggleInputs('lssa' + lssa.index);
            }
        },
        //funzione che inizializza le variabili di selezione con i valori attualmente configurati, eppoi setta a true la variabile configLssa
        //che rende configurabili le proprietà 'program', 'ingresso' e 'negated'
        initConfig(lssa) {
            this.selectedProgram = lssa.inputs.map(input => input.program);
            this.selectedIngresso = lssa.inputs.map(input => input.address);
            this.selectedNegated = lssa.inputs.map(input => input.negated);
            this.configLssa = true; 
            this.editingIndex = lssa.index;
            //nel caso di visualizzazione a card, apro il collapse degli ingressi
            if (this.isOpen['lssa' + lssa.index] === false) {
                this.toggleInputs('lssa' + lssa.index);
            }
        },

        //funzioni che inviano a Centrali.vue gli eventi generati in LssaDetails.vue
        forwardEditing(payload) {
            this.$emit('editing-lssa', payload);
        },
        forwardingUpdating(payload) {
            this.$emit('updating-lssa', payload);
        },

        toggleInputs(obj)
        {
            console.log("Collapse-" + obj);
            
            if (!(obj in this.isOpen)) {
                this.$set(this.isOpen, obj, true); // make it reactive
            } else {
                this.isOpen[obj] = !this.isOpen[obj];
            }

            //this.isOpen[id]=!this.isOpen[id];
            console.log("isOpen: ",this.isOpen[obj]);
            this.$root.$emit('bv::toggle::collapse', 'collapse-' + obj);
        },
        //restituisce la stringa i18n relativa allo stato degli ingressi LSSA rispetto alla funzione configurata
        decodificaLSSA(ingresso,lssa)
        {
            if (ingresso.state == 1)
            { 
                if(lssa.device_type=='90' || lssa.index=='97')
                    {
                        return "lssa.closed";
                    } 
                else if(lssa.device_type=='91')
                    {
                        return "lssa.rete_presente";
                    }
            }
            else
            {        
                if(lssa.device_type=='90'|| lssa.index=='97')
                    {
                        return "lssa.open";
                    } 
                else if(lssa.device_type=='91')
                    {
                        return "lssa.rete_assente";
                    }
            }            
        },

        showLssaDetails(lssa)
        {
            this.currentLssa = lssa;
            this.modalLssaDetailShow = true;
        },
        //funzione che raccoglie le nuove description
        saveDescLssa(currentLssa) {
            this.editingDesc = false;
            var params ={};
            params.cu_id = currentLssa.cu_id.split('#')[1];
            params.command = "setLssaDesc";
            params.lssa_module_index = Number(currentLssa.index).toString();
            params.topic = currentLssa.cu_type + '_' + currentLssa.cu_id.split('#')[1];
            params.desc = this.descInput;
            params.module_desc = this.descLssa;
            this.sendDesc(params);
        },
        //funzione che raccoglie i parametri e li passa alla funzione che invia il comando di aggiornamento della configurazione ingressi LSSA
        saveConfigLssa(currentLssa)
        { 
            console.log("currentLssa: ", currentLssa);           
            this.configLssa = false;
            var params ={};
            params.cu_id = currentLssa.cu_id.split('#')[1];
            params.command = "configLSSA_modulo";
            params.lssa_module_index = Number(currentLssa.index).toString();
            params.topic = currentLssa.cu_type + '_' + currentLssa.cu_id.split('#')[1];
            params.functions = this.selectedProgram;
            params.addresses = this.selectedIngresso;
            params.negated = this.selectedNegated.map(input => input.negated === 'ON' ? 1 : 0); //trasformo in array di 0 e 1
            console.log("saveConfigLssa - params: ", params);
            console.log("sendConfig: ", this.sendConfig);
            this.sendConfig(params);
        },
    }

}
</script>

<style>
.b-button-group .btn {
  min-width: 48px;
  min-height: 48px;
}

.placeholder-weight::placeholder {
  font-weight: normal;
}

.fixed-card {
    position: fixed;
    bottom: 48px; /*adjust to the height of the last component*/
    left: 0;
    right: 0;
    display: flex;
    z-index: 1000;
    justify-content: center;
}
</style>
